import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrderEntryService } from '../../../../services/order-entry.service';

@Component({
    selector: 'create-remittance-dialog',
    templateUrl: 'create-remittance.component.html',
})
export class CreateRemittanceDialog {

    orders;

    constructor(
        private orderEntryService: OrderEntryService,
        public dialogRef: MatDialogRef<CreateRemittanceDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
            this.orders = data.filter(order => order.remittanceId != 0);

    }

}